import { Md5 } from 'ts-md5/dist/md5';

const getHashKey = (query: string, variables: any = {}) => Md5.hashStr(`${query}-${JSON.stringify(variables)}`);

export default getHashKey;
